import React from 'react';
import './UserName.scss';

const UserName = ({ user, toggleDropdown, onClick }) => {
  if (user) {
    return (
      <div className="odUserName">
        <div className="odUserName__name" onClick={onClick}>
          <span className="odUserName__name__span">
            {user?.firstName} {user?.lastName}
          </span>
          <img
            alt="arrow"
            className={`
              odUserName__arrowIcon 
              ${toggleDropdown && 'odUserName__arrowRotate'}
              `}
            src="https://static.lenskart.com/media/owndays/minified/arrow-up.webp"
          />
        </div>
      </div>
    );
  }

  return null;
};

export default UserName;
